import { BrowserRouter, Routes, Route } from 'react-router';
import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import SignUpPage from '../pages/SignUpPage';
import LogoutPage from '../pages/LogoutPage';
import NotRegisteredPage from '../pages/NotRegisteredPage'
import UpdatePasswordPage from '../pages/UpdatePasswordPage';
import AllAppsPage from '../pages/AllAppsPage';
import ActivationPage from '../pages/ActivationPage';
import {getCurrentApp, AppDomains} from '../util/AppUtil';
import { Typography, Grid } from '@mui/material';

const AppRouter = () => {

    const getAppDomain = getCurrentApp();
    const isAppDomainTyno = getAppDomain === AppDomains.TYNO;
    const isAppDomainEprocessify = getAppDomain === AppDomains.EPROCESSIFY;
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/login' element={<LoginPage isAppDomainTyno={isAppDomainTyno}/>} />
                <Route path='/register' element={<SignUpPage isAppDomainTyno={isAppDomainTyno}/>} />
                <Route path="/" element={<DashboardPage isAppDomainTyno={isAppDomainTyno}/>}/>
                <Route path="/not-registered" element={<NotRegisteredPage isAppDomainTyno={isAppDomainTyno}/>}/>
                <Route path="/logout" element={<LogoutPage/>}/>
                {/* <Route path="/apps" element={<AllAppsPage isAppDomainTyno={isAppDomainTyno}/>} /> */}
                <Route path="/update-password" element={<UpdatePasswordPage isAppDomainTyno={isAppDomainTyno}/>} />
                <Route path="/activate" element={<ActivationPage isAppDomainTyno={isAppDomainTyno}/>} />
                <Route path="*" element={<div>
                                            <Grid container sx={{justifyContent: 'center'}}>
                                                <Typography variant='h3' style={{marginTop:"32px"}}>
                                                    Page Not Found!
                                                </Typography>
                                            </Grid>
                                             </div>} />
            </Routes>
        </BrowserRouter>
        );
    }

export default AppRouter;